import { onAuthStateChanged } from "firebase/auth";
import { getFirebaseAuth } from "../../firebase/firebaseService";
import { getAuthConfig } from "../../config/AuthConfigContext";
import { checkingLoggedInUser, loginSuccess, resetAllStates } from "../authSlice";
import type { AuthAppDispatch } from "../store";

export const getCurrentUser = () => async (dispatch: AuthAppDispatch) => {
  dispatch(checkingLoggedInUser());
  const firebaseAuth = getFirebaseAuth();
  const config = getAuthConfig();

  onAuthStateChanged(firebaseAuth, (user) => {
    if (user) {
      const userDetails = {
        email: user.email ?? "",
        id: user.uid,
      };

      config?.analytics?.setUser?.({
        id: userDetails.id,
        email: userDetails.email,
      });

      dispatch(loginSuccess(userDetails));
      config?.onAuthStateChange?.(userDetails);
    } else {
      config?.analytics?.clearUser?.();
      dispatch(resetAllStates());
      config?.onAuthStateChange?.(null);
    }
  });
};
